import {
  LearningObjectiveStatementStatus,
  OrderType,
  useSearchLearningObjectiveStatementsLazyQuery,
} from '@exam-management/graphql';
import type { OptionSelectionProps } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

interface UseFetchLosProps {
  chapterLevelItemId: string | null;
  contentType: 'LOS' | 'TOPIC';
}

export default function useFetchLos(props: Readonly<UseFetchLosProps>) {
  const { chapterLevelItemId, contentType } = props;

  const [options, setOptions] = useState<OptionSelectionProps[]>([]);

  const [searchLOS, { data: searchLOSResults, loading: isSearchLOSLoading }] =
    useSearchLearningObjectiveStatementsLazyQuery({
      fetchPolicy: 'network-only',
    });

  const fetchLOS = useCallback(async () => {
    await searchLOS({
      variables: {
        search: {
          chapterLevelItemId,
          status: LearningObjectiveStatementStatus.Published,
        },
        paging: {
          pageSize: 100,
          currentPage: 0,
        },
        order: {
          field: 'updatedAt',
          type: OrderType.Asc,
        },
      },
    });
  }, [chapterLevelItemId, searchLOS]);

  useEffect(() => {
    const losOptions =
      searchLOSResults?.qbsSearchLearningObjectiveStatements?.learningObjectiveStatements
        .map((los) => ({
          label: los.tag.name,
          value: los.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) ?? [];
    setOptions(losOptions);
  }, [searchLOSResults]);

  useEffect(() => {
    if (contentType === 'LOS' && chapterLevelItemId) {
      fetchLOS();
    }
  }, [contentType]);

  return {
    options,
    isSearchLOSLoading,
  };
}
